import React, { memo, useMemo } from 'react';
import _ from 'lodash';
import BlankSlate from '../../blocks/BlankSlate';
import SkeletonLoader from '../../../atoms/SkeletonLoader';
import Button from '../../../atoms/buttons/Button';
import FavoritesProfileGridView from './FavoritesProfileGridView';
import FavoritesProfileListView from './FavoritesProfileListView';
import TrackLoadingToMixpanel from '../../common/TrackLoadingToMixPanel';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';

interface FavoritedListProps {
  noResultsTitle: string;
  noResultsMsg: string;
  noResultsImg: string;
  page: string;
  viewType: string;
  pageTitle?: string;
  favorites?: any;
  themeDarkMode?: any;
}

const FavoritedList = ({
  noResultsTitle,
  noResultsMsg,
  noResultsImg,
  page,
  viewType,
  pageTitle,
}: FavoritedListProps): any => {
  const fav = useSelector((state: RootState) => state.fav);
  const { isFetching } = fav;
  const favorites = useMemo(() => fav[page], [fav, page]);

  // loop through each mail item.
  if (_.isEmpty(favorites) && isFetching)
    return (
      <>
        <TrackLoadingToMixpanel page={`Interests - ${pageTitle}`} />
        <SkeletonLoader width="100%" />
      </>
    );

  const getMatched = fav => {
    if (page === 'viewed_me') {
      return fav.is_matched;
    }

    const member = fav.other_account.data;

    if (page === 'from') {
      return fav.favorited_me;
    }

    return member.is_favorite && fav.favorited_me;
  };

  if (!_.isEmpty(favorites)) {
    return (
      <>
        {Object.keys(favorites).map(key => {
          const member = favorites[key].other_account.data;
          const offer = favorites[key].offer;
          const isMatched = getMatched(favorites[key]);
          const isMyFavorite = page === 'viewed_me' ? favorites[key].is_favorited : member.is_favorite;
          const isFavoritedMe = favorites[key].favorited_me;

          if (viewType === 'list') {
            return (
              <FavoritesProfileListView
                key={key}
                favKey={key}
                profile={member}
                isFavorite={isMyFavorite}
                isFavoritedMe={isFavoritedMe}
                isMatched={isMatched}
                offer={offer}
                title={member.username}
                hashId={member.hash_id}
                page={page}
                timestamp={
                  typeof favorites[key].created_at === 'string'
                    ? favorites[key].created_at
                    : favorites[key].created_at.date
                }
                pageTitle={pageTitle}
              />
            );
          }

          return (
            <FavoritesProfileGridView
              key={key}
              favKey={key}
              profile={member}
              isFavorite={isMyFavorite}
              isFavoritedMe={isFavoritedMe}
              isMatched={isMatched}
              offer={offer}
              hashId={member.hash_id}
              page={page}
              pageTitle={pageTitle}
            />
          );
        })}
      </>
    );
  } else if (_.isEmpty(favorites) && !isFetching) {
    const actionBtn = (
      <Button buttonType="primaryRed" to="/search">
        Find a date
      </Button>
    );

    return <BlankSlate img={noResultsImg} title={noResultsTitle} message={noResultsMsg} action={actionBtn} />;
  }
};

export default memo(FavoritedList);
